// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__JiWjg","title":"Modal_title__E4Jg8","description":"Modal_description__yTDXE"};